// extracted by mini-css-extract-plugin
export default {"animate":"OverlayAnimate-module_animate_LCp08","shine":"OverlayAnimate-module_shine_ZMDKa"};